import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const AuthContext = createContext();
export const AuthProvider = ({ children }) => {
	const [user, setUser] = useState(null);
	const [token, setToken] = useState(secureLocalStorage.getItem("token") || null);
	const [loading, setLoading] = useState(true);
	const navigate = useNavigate();
	
	const verifyToken = async (token, user) => {
	  if (token && user) {
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				user:user,
				token:token,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/verify-token", payload);
			const { responseCode, responseMsg } = res.data;
			
			if (responseCode === "200") {
				
			}else{
				logout();
			}				
		} catch (err) {			  
		  logout();
		}
	  }else{
		 logout();
	  }
	  
	};
	
	const login = async (user, password) => {
		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				email:user,
				user_password:password,
			};
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const res = await api.post("/career-login", payload);
			const { responseCode, responseMsg } = res.data;
			if (responseCode === "200") {
				secureLocalStorage.setItem("token", res.data.token);
				secureLocalStorage.setItem("user", res.data.applicant_email);
				secureLocalStorage.setItem("name", res.data.applicant_name);
				secureLocalStorage.setItem("father_name", res.data.father_name);
				secureLocalStorage.setItem("mother_name", res.data.mother_name);				
				secureLocalStorage.setItem("mobile_number", res.data.mobile_number);				
				secureLocalStorage.setItem("gender", res.data.gender);				
				secureLocalStorage.setItem("picture", res.data.picture);			
				
				setToken(res.data.token);
				setUser(res.data.applicant_email);
				
				axios.defaults.headers.common["Authorization"] =
				  `Bearer ${res.data.token}`;
				return { success: true };
			}else{
				return { success: false, message: res.data.responseMsg };
			}			  
		} catch (err) {
			console.log(err);
			return { success: false, message: "Login failed" };
		}
	};
	const logout = () => {
		secureLocalStorage.removeItem("token");
		secureLocalStorage.removeItem("user");
		secureLocalStorage.removeItem("name");
		secureLocalStorage.removeItem("mobile_number");
		secureLocalStorage.removeItem("gender");		
		secureLocalStorage.removeItem("picture");		
		delete axios.defaults.headers.common["Authorization"];
		setToken(null);
		setUser(null);
		navigate("/login", { replace: true });
	};
	return (
		<AuthContext.Provider value={{ user, token, loading, login, logout, verifyToken }}>
		  {children}
		</AuthContext.Provider>
	);
}
export const useAuth = () => useContext(AuthContext);